package games.polyclub.website.frontend.store.pages.logged

import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.new
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.useEffectOnceAsync
import games.polyclub.message.unaryMinus
import games.polyclub.service.profile.api.PaymentProfile
import games.polyclub.service.profile.api.PlayerProfile
import games.polyclub.tool.functional.Option
import games.polyclub.tool.functional.retrying
import games.polyclub.tool.strings.formatted
import games.polyclub.website.frontend.store.StoreBff
import games.polyclub.website.frontend.store.appScope
import games.polyclub.website.frontend.store.components.Loading
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.hooks.useAuth
import games.polyclub.website.frontend.store.layout.userarea.UserAreaLayout
import games.polyclub.website.frontend.store.pages.RegisterLocationState
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import js.core.jso
import kotlinx.coroutines.launch
import react.Fragment
import react.Props
import react.router.dom.Link
import react.router.useLocation
import react.useState
import web.cssom.rem

val ChangePaymentProfilePage = SFC<Props> { _ ->
    val authCtx = useAuth()
    val location = useLocation()
    val (profile, setProfile) = useState<PlayerProfile?>(null)
    val (paymentProfile, setPaymentProfile) = useState<Option<PaymentProfile>?>(null)

    appScope.useEffectOnceAsync {
        retrying {
            val result = authCtx.reloadProfile().await() ?: return@retrying
            setProfile(result.profile)
        }
    }

    appScope.useEffectOnceAsync {
        setPaymentProfile(retrying {
            StoreBff.loadPaymentProfile()
        })
    }

    UserAreaLayout {
        addBreadcrumb(LoggedSitemap.MANAGE_PAYMENT_PROFILE.path, -"Dados de Cobrança")
        Card {
            title = "Alterar Dados de Cobrança"

            if (profile == null || paymentProfile == null) {
                Loading()
                return@Card
            }

            paymentProfile.ifEmpty {
                p {
                    +"Nenhum dado de cobrança registrado, os dados podem ter sido excluídos ou o tempo de armazenamento expirado."
                }
            }.ifPresent { paymentProfile ->
                table("table") {
                    tr {
                        th("border-top-0") {
                            style = jso {
                                width = 9.rem
                            }
                            +"Nome:"
                        }
                        td("border-top-0") {
                            +paymentProfile.firstName
                        }
                    }
                    tr {
                        th {
                            +"Sobrenome:"
                        }
                        td {
                            +paymentProfile.lastName
                        }
                    }
                    tr {
                        th {
                            +"E-mail:"
                        }
                        td {
                            +paymentProfile.email.secret
                        }
                    }
                    tr {
                        th {
                            +"Reside no Brasil?"
                        }
                        td {
                            +if(paymentProfile.brazilian) "Sim" else "Não"
                        }
                    }
                    if (paymentProfile.brazilian) {
                        tr {
                            th {
                                +"CPF:"
                            }
                            td {
                                +paymentProfile.cpf?.secret?.let {
                                    "${it.substring(0, 3)}.${it.substring(3, 6)}.${it.substring(6, 9)}-${it.substring(9)}"
                                }
                            }
                        }
                    }
                    tr {
                        th {
                            +"Armazenado até:"
                        }
                        td {
                            +paymentProfile.expiresAt.formatted()
                        }
                    }
                }
            }

            footer = Fragment.new {
                Link("btn btn-primary") {
                    to = LoggedSitemap.REGISTER_PAYMENT_PROFILE.path
                    state = jso<RegisterLocationState> {
                        returnLocation = location.pathname
                        returnState = location.state
                    }
                    +"Alterar Dados"
                }
                if (paymentProfile.isPresent) {
                    button("btn btn-danger float-right") {
                        +"Apagar Dados"
                        onClick = {
                            setPaymentProfile(null)
                            appScope.launch {
                                retrying {
                                    StoreBff.deletePaymentProfile()
                                }
                                launch {
                                    retrying {
                                        setProfile(authCtx.reloadProfile().await()?.profile ?: return@retrying)
                                    }
                                }
                                launch {
                                    setPaymentProfile(retrying {
                                        StoreBff.loadPaymentProfile()
                                    })
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
